import components from './components';
import services from './services';
import './groups/groups';
import './profile/profile';

const module = angular.module('websked.settings', ['websked.groups', 'websked.profile']);

const toLoad = [
  components,
  services
];

toLoad.forEach(fn => fn(module));
